import React from "react";
import FeedbackContainer from "../Shared/FeedbackContainer";

export default function TeamLeaderFeedbackContainer() {
    return (
        <FeedbackContainer view='Team Leader' />
    );
}